export const MIN_DEVICE_ID_LENGTH = 8;
export const MAX_DEVICE_ID_LENGTH = 64;
export const MAX_ACCOUNT_DEVICE_ID_LENGTH = 128;

/** Strict identifier emitted by current wireless firmware INFO frames. */
export function validDeviceId(value: unknown): value is string {
  return typeof value === 'string' && /^[A-Za-z0-9_.:-]{8,64}$/.test(value);
}

/** Historical enrollment/account identifier contract. Wireless INFO has its own stricter validator above. */
export function validAccountDeviceId(value: unknown): value is string {
  return typeof value === 'string' && value.length >= MIN_DEVICE_ID_LENGTH && value.length <= MAX_ACCOUNT_DEVICE_ID_LENGTH;
}
